export type AssignmentType = {
  id: string;
  scope: { task: string; reviewed: boolean; completed: boolean }[];
  estimator_type: EstimatorType;
  total_scope_items: number;
  completed_scope_items: number;
  reviewed_scope_items: number;
  estimated_minutes: number;
  start_date: string;
  end_date: string;
  user: {
    id: string;
    name: string;
  };
};

export type TakeoffAssignmentScopeTypeAT = {
  trade_name: string;
  trade_id: string;
  status: TakeoffStatusEnum;
  takeoff_id: string;
  assignments: AssignmentType[];
};

export type TakeoffAssignmentScopeType = TakeoffAssignmentScopeTypeAT[];

export enum EstimatorType {
  QUALITY_CONTROL = 'QUALITY_CONTROL',
  QUALITY_ASSURANCE = 'QUALITY_ASSURANCE'
}

export enum TakeoffStatusEnum {
  TRADE_UNASSIGNED = 'trade_unassigned',
  TEAM_UNASSIGNED = 'team_unassigned',
  USER_UNASSIGNED = 'user_unassigned',
  TAKEOFF_SCOPING = 'takeoff_scoping',
  // TAKEOFF_IN_REVIEW = 'takeoff_in_review',
  WAITING_FOR_QC = 'waiting_for_qc',
  IN_PROGRESS_QC = 'in_progress_qc',
  WAITING_FOR_QA = 'waiting_for_qa',
  IN_PROGRESS_QA = 'in_progress_qa',
  FINAL_REVIEW_PENDING = 'final_review',
  COMPLETED = 'completed'
}
